import api, { armorAPI } from '~/services/api';
import { JSONParcelTemplate } from '~/types/ParcelTemplate';

function get() {
  return armorAPI.request({
    url: `/setting/package-units`,
    method: 'GET',
  });
}

function put(data) {
  return armorAPI.request({
    data,
    url: `/setting/package-units`,
    method: 'PUT',
  });
}

function updateOldExperience(data, objectId: string) {
  return api.request({
    data,
    url: `/ui/account/parcel_templates/${objectId}`,
    method: 'PUT',
  });
}

function update(data, objectId: string) {
  return armorAPI.request({
    data,
    url: `/setting/parcel_templates/${objectId}`,
    method: 'PUT',
  });
}

function createOldExperience(data) {
  return api.request({
    data,
    url: `/ui/account/parcel_templates`,
    method: 'POST',
  });
}

function create(data) {
  return armorAPI.request({
    data,
    url: '/setting/parcel_templates',
    method: 'POST',
  });
}

function delOldExperience(objectId: string) {
  return api.request({
    url: `/ui/account/parcel_templates/${objectId}`,
    method: 'DELETE',
  });
}

function del(objectId: string) {
  return armorAPI.request({
    url: `/setting/parcel_templates/${objectId}`,
    method: 'DELETE',
  });
}

function getRecents() {
  return armorAPI.request<{ results: JSONParcelTemplate[] }>({
    url: '/user-parcel-templates/recent',
    method: 'GET',
  });
}

export {
  get,
  getRecents,
  put,
  update,
  updateOldExperience,
  create,
  createOldExperience,
  del,
  delOldExperience,
};
